import { render, staticRenderFns } from "./index.vue?vue&type=template&id=187af6ba&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=187af6ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187af6ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('187af6ba')) {
      api.createRecord('187af6ba', component.options)
    } else {
      api.reload('187af6ba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=187af6ba&scoped=true&", function () {
      api.rerender('187af6ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/hld/index.vue"
export default component.exports